import { render, staticRenderFns } from "./ChainPage.vue?vue&type=template&id=f7d47c46"
import script from "./ChainPage.vue?vue&type=script&lang=js"
export * from "./ChainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports